import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { E404Component } from './base/e404/e404.component';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { HomeGuardService } from './core/guards/home-guard.service';
import { LoginGuardService } from './core/guards/login-guard.service';
import { PublicGuardService } from './core/guards/public-guard.service';
import { PublicRedirectGuardService } from './core/guards/public-redirect-guard.service';
import { FinishOperationGuardService } from './services/finishOperation-guard.service';

const routes: Routes = [
  {
    path: '',
    canActivate: [HomeGuardService],
    component: AppComponent,
    pathMatch: 'full'
  },
  {
    path: 'finishOperation',
    canActivate: [PublicRedirectGuardService, PublicGuardService, FinishOperationGuardService],
    loadChildren: () => import('./finish/finish.module').then((mod) => mod.FinishModule)
  },
  {
    path: 'finishProOperation/:id',
    canActivate: [PublicRedirectGuardService, PublicGuardService],
    loadChildren: () => import('./finish-pro/finish-pro.module').then((mod) => mod.FinishProModule)
  },
  {
    path: 'verification',
    canActivate: [PublicGuardService],
    loadChildren: () => import('./verification/verification.module').then((mod) => mod.VerificationModule)
  },
  {
    path: 'verificacion',
    canActivate: [PublicGuardService],
    loadChildren: () => import('./verification/verification.module').then((mod) => mod.VerificationModule)
  },
  {
    path: 'login',
    canActivate: [LoginGuardService, PublicGuardService],
    data: {
      checkLogin: true
    },
    loadChildren: () => import('./login/login.module').then((mod) => mod.LoginModule)
  },
  {
    path: 'register',
    canActivate: [PublicGuardService],
    loadChildren: () => import('./register/register.module').then((mod) => mod.RegisterModule)
  },
  {
    path: '',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./base/base.module').then((mod) => mod.BaseModule)
  },

  {
    path: '*',
    loadChildren: () => import('./base/legacy/legacy.module').then((mod) => mod.LegacyModule)
  },
  {
    path: '**',
    component: E404Component
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
